export default {
    init() {
        const backgrounds = document.querySelectorAll('[data-parallax-bg]')

        backgrounds.forEach(container => {
            const background = container.querySelector('[data-background]')

            gsap.fromTo(
                background,
                { y: '-25%' },
                { y: '25%', ease: 'none', scrollTrigger: { trigger: container, scrub: true } },
            )
        })
    },
}
